import React from "react";
import { pencilIcon } from "../SVG";
export default function TextAreaWithReadOnly({
  label,
  onChange,
  value,
  type,
  placeholder,
  error,
  errorText,
  row,
  textAreaRef,
  defaultValue,
  readOnly,
  onClickPencil,
  showShareButton
}) {

  return (
    <div className="input__outer">
      {label && <label className="label-with-icon">{label}
      </label>}
      <div className="input">
        <textarea
          ref={textAreaRef}
          cols="30"
          rows={row ? row : "5"}
          onChange={onChange}
          value={value}
          defaultValue={defaultValue}
          type={type}
          placeholder={placeholder}
          readOnly={readOnly}
        ></textarea>
      </div>
      {error && value === "" && <div className="input__error">{errorText}</div>}
    </div>
  );
}
